<div class="flex min-h-screen surface-ground">
	<div class="layout-main w-full">
		<div class="layout-content flex justify-content-center surface-ground">
			<div class="grid max-w-full text-900" [ngClass]="minHeightScreen()">
					<div class="col-12 flex align-items-end justify-content-center">
						<img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/CAME-A_alpha_white_blue.png' : './assets/images/logos/CAME-A_alpha_white.png'" alt="Login Logo" class="my-5 w-14rem">
					</div>
					<div class="col-12 flex align-items-center justify-content-center">
						<div class="card surface-800 border-round flex align-items-center justify-content-center p-0">
							<div *ngIf="!maintenance" class="grid col-12 flex align-items-center p-0">
								<div class="col-12 lg:col-6 py-5 px-5 lg:px-6">
									<div class="text-center text-0 text-xl font-bold lg:mb-3">
										{{ 'LOGIN_WELCOME' | translate }}
									</div>
									<div class="text-center text-0 text-base mb-7 hidden-under-lg">
										{{ 'LOGIN_HEADER' | translate }}
									</div>
									<div class="hidden-under-lg">
										<button pButton pRipple (click)="signNewUser()"
											label="{{ 'NEW_USER' | translate }}" routerLink="/signup/user"
											class="p-button-primary text-normal font-semibold mb-4 w-full">
										</button>
										<button pButton pRipple (click)="signNewTechnician()"
											label="{{ 'NEW_TECHNICIAN' | translate }}" routerLink="/signup/technician"
											class="p-button-primary text-normal font-semibold w-full">
										</button>
										<div class="text-center mt-3">
											<p-button (click)="helpDialog()" styleClass="text-0 text-sm font-semibold" label="{{ 'NEED_HELP' | translate }}" [link]="true"></p-button>
										</div>
									</div>
								</div>
								<div class="col-12 lg:col-6 pt-0 lg:pt-5 pb-5 px-5 lg:px-6">
									<div class="text-left text-0 text-xl font-bold mb-3">{{ 'LOGIN' | translate }}</div>
									<div class="text-left text-base">
										<form (ngSubmit)="login()" [formGroup]="loginForm" autocomplete="on">
											<label for="usernamelabellogin" class="block text-0 text-base mb-2">{{ 'EMAIL' | translate }}</label>
											<input id="usernameinputlogin" pInputText noSpaces type="text" 
												pAutoFocus 
												[autofocus]="true" 
												placeholder="{{ 'EMAIL' | translate }}" 
												formControlName="username"
												class="mb-5 w-full surface-900 border-1 border-bluegray-200 text-sm p-3 h-3rem" 
												autocomplete="on">
											<label for="passwordlabellogin" class="block text-0 text-base mb-2">{{ 'PASSWORD' | translate }}</label>
											<p-password inputId="login-input-password" placeholder="{{ 'PASSWORD' | translate }}" [toggleMask]="true"
																	styleClass="mb-5 w-full h-3rem" inputStyleClass="pl-6 surface-900 border-1 border-bluegray-200 w-full text-sm"
																	[feedback]="false" formControlName="password" maxLength="64">
											</p-password>
											<ng-template pTemplate="showicon">
												<div class="flex h-full align-items-center">
													<p-button icon="pi cm-eye" styleClass="p-button-rounded p-button-text"></p-button>
												</div>
											</ng-template>
											<ng-template pTemplate="hideicon">
												<div class="flex h-full align-items-center">
													<p-button icon="pi cm-eye-not" styleClass="p-button-rounded p-button-text"></p-button>
												</div>
											</ng-template>
											<button pButton pRipple
												label="{{ 'LOGIN' | translate }}" (click)="login()"
												class="p-button-primary text-normal font-semibold w-full">
											</button>
										</form>
										<div class="text-center mt-3">
											<p-button (click)="resetPasswordModal()" styleClass="text-0 text-sm font-semibold" label="{{ 'PASSWORD_RESET' | translate }}" [link]="true"></p-button>
										</div>
									</div>
									<div class="border-top-1 border-300 my-4 hidden-over-lg"></div>
									<div class="hidden-over-lg">
										<button pButton pRipple (click)="signNewUser()"
											label="{{ 'NEW_USER' | translate }}" routerLink="/signup/user"
											class="p-button-primary text-normal font-semibold mb-4 w-full">
										</button>
										<button pButton pRipple (click)="signNewTechnician()"
											label="{{ 'NEW_TECHNICIAN' | translate }}" routerLink="/signup/technician"
											class="p-button-primary text-normal font-semibold w-full">
										</button>
										<div class="text-center mt-3">
											<p-button (click)="helpDialog()" styleClass="text-0 text-sm font-semibold" label="{{ 'NEED_HELP' | translate }}" [link]="true"></p-button>
										</div>
									</div>
								</div>
							</div>
							<div *ngIf="maintenance" class="grid flex align-items-center">
								<div class="col-12 text-center text-0 text-xl font-bold mt-5 mb-3">
									{{ 'LOGIN_WELCOME' | translate }}
								</div>
								<div class="col-12 text-center text-0 pb-3">
									<i class="pi cm-wip text-5xl"></i>
								</div>
								<div class="col-12 text-center text-0 text-xl font-bold pb-3">
									{{ 'MAINTENANCE_LIVE' | translate }}
								</div>
								<div class="col-12 text-center text-0 text-base pb-3">
									{{ 'MAINTENANCE_MESSAGE1' | translate }}
								</div>
								<div class="col-12 text-center text-0 text-base mb-6">
									{{ 'MAINTENANCE_MESSAGE2' | translate }}
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 flex align-items-start justify-content-center">
						<img [src]="getMenuTheme() === 'dim' ? './assets/images/logos/cameconnect-main.png' : './assets/images/logos/cameconnect-whiteblack.png'" alt="Came Connect logo" class="my-5 w-22rem">
					</div>
					<div [ngClass]="onLargeDesktop()">
						<label class="h-10rem"></label>
					</div>
			</div>
		</div>

		<app-login-footer [ngClass]="fixedFooter()"></app-login-footer>

		<p-confirmDialog #confDialog>
			<ng-template pTemplate="footer">
				<div class="col-12 flex justify-content-center">
					<button type="button" pButton
							[label]="confDialog.acceptButtonLabel"
							[ngClass]="acceptButtonStyle"
							(click)="confDialog.accept()">
					</button>
					<button type="button" pButton *ngIf="rejectButtonVisible"
							[label]="confDialog.rejectButtonLabel"
							[ngClass]="rejectButtonStyle"
							(click)="confDialog.reject()">
					</button>
				</div>
			</ng-template>
		</p-confirmDialog>
	</div>
</div>